/* global angular */

angular.module('atex.aceui.service').factory('LocalizationService', ['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',
  ($q, $rootScope, AuthenticationService, ApplicationConfigurationService) => {
    var serviceHandler = undefined;

    const handler = () => {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('LocalizationService').then((configuration) => {
        return atex.aceui.ServiceUtils.calculateServiceUrl(configuration, '/localization');
      })
        .then((serviceUrl) => {
          var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope) };
          serviceHandler = atex.aceui.service.LocalizationService(serviceUrl, serviceSettings);

          return serviceHandler;
        });
    };

    return {
      getLocalization: ({ localizationContexts, languageKey }) => {
        return handler().then((localizationService) => {
          return localizationService.getLocalization({ localizationContexts, languageKey });
        });
      }
    };
  }]);
